import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  applicationSummary: {
    applicationName: '',
    archetypeCode: '',
    riskTier: '',
    modifiers: [],
  },
  trustWeights: {
    Accuracy: 0,
    Fairness: 0,
    Security: 0,
    Privacy: 0,
    Robustness: 0,
    Explainability: 0,
    Ethics: 0,
  },
  risks: [],
  loading: false,
  error: null,
};

const riskSlice = createSlice({
  name: 'risk',
  initialState,
  reducers: {
    setApplicationSummary: (state, action) => {
      state.applicationSummary = { ...state.applicationSummary, ...action.payload };
    },
    setTrustWeights: (state, action) => {
      state.trustWeights = { ...state.trustWeights, ...action.payload };
    },
    setRisks: (state, action) => {
      state.risks = action.payload;
    },
    addRisk: (state, action) => {
      state.risks.push(action.payload);
    },
    updateRisk: (state, action) => {
      const { index, data } = action.payload;
      state.risks[index] = { ...state.risks[index], ...data };
    },
    removeRisk: (state, action) => {
      state.risks = state.risks.filter((_, index) => index !== action.payload);
    },
    setRiskData: (state, action) => {
      return { ...state, ...action.payload, loading: false, error: null };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    resetRisk: () => initialState,
  },
});

export const {
  setApplicationSummary,
  setTrustWeights,
  setRisks,
  addRisk,
  updateRisk,
  removeRisk,
  setRiskData,
  setLoading,
  setError,
  resetRisk,
} = riskSlice.actions;

export default riskSlice.reducer;
